import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import i18n from 'i18next'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemText from '@material-ui/core/ListItemText'

const styles = {
  formControl: {
    margin: '1rem'
  },
  whiteColor: {
    color: 'white'
  }
}

const langsData = {
  en: { label: 'English (US)', image: 'en.png' },
  es: { label: 'Español (MX)', image: 'mx.png' },
  fr: { label: 'Français', image: 'fr.png' },
  fr_CA: { label: 'Français (CA)', image: 'fr-ca.png' },
  pl: { label: 'Polski', image: 'pl.png' }
}

// eslint-disable-next-line react/prop-types
function LanguageSwitcher({ classes, langs, onLangChange }) {
  const getCurrentLang = (_) => {
    const cl = i18n.language
    // eslint-disable-next-line react/prop-types
    if (!langs.includes(cl)) {
      i18n.changeLanguage('en')
      return 'en'
    } else {
      return cl
    }
  }

  const onChange = (e) => {
    i18n.changeLanguage(e.target.value)
    if (onLangChange) {
      onLangChange(e.target.value)
    }
  }

  // eslint-disable-next-line react/prop-types
  return !langs || langs.length === 0 ? null : (
    // eslint-disable-next-line react/prop-types
    <FormControl variant="outlined" className={classes.formControl}>
      <Select
        disableUnderline
        variant="outlined"
        value={getCurrentLang()}
        onChange={onChange}
        classes={{
          // eslint-disable-next-line react/prop-types
          root: classes.whiteColor,
          // eslint-disable-next-line react/prop-types
          icon: classes.whiteColor
        }}
      >
        {
          // eslint-disable-next-line react/prop-types
          langs.map((lng) => (
            <MenuItem value={lng} key={`lang-${lng}`}>
              <ListItemIcon>
                <img width="40px" height="25px" src={`/img/flags/${langsData[lng].image}`} alt={lng} />
              </ListItemIcon>
              <ListItemText disableTypography primary={langsData[lng].label} style={{ paddingLeft: 0 }} />
            </MenuItem>
          ))
        }
      </Select>
    </FormControl>
  )
}

export default withStyles(styles)(LanguageSwitcher)
